export const isMagicFrameInEditing = () => {
  const active =
    window.canvas && window.canvas.getActiveObject
      ? window.canvas.getActiveObject()
      : null;
  if (!active) return false;
  if (active.type === 'image' && active._magicFrame) {
    return !!active._magicFrame.isEditing;
  }
  return !!active.isEditing;
};
